/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserSignInResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'UserSignInResponseData',
        isRequired: true,
      },
    },
  }],
} as const;
